import { render, staticRenderFns } from "./LegalDocumentAttachments.vue?vue&type=template&id=2062ca66&scoped=true&"
import script from "./LegalDocumentAttachments.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentAttachments.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentAttachments.vue?vue&type=style&index=0&id=2062ca66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2062ca66",
  null
  
)

export default component.exports